/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RetailerEmailUserInput,
    RetailerEmailUserInputFromJSON,
    RetailerEmailUserInputFromJSONTyped,
    RetailerEmailUserInputToJSON,
} from './';

/**
 * 
 * @export
 * @interface RetailerEmailRequest
 */
export interface RetailerEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof RetailerEmailRequest
     */
    retailerEmail: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerEmailRequest
     */
    retailerName: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerEmailRequest
     */
    retailerCity: string;
    /**
     * 
     * @type {Array<RetailerEmailUserInput>}
     * @memberof RetailerEmailRequest
     */
    userInputs: Array<RetailerEmailUserInput>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RetailerEmailRequest
     */
    consents?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerEmailRequest
     */
    hidePdfPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RetailerEmailRequest
     */
    siteUrl?: string | null;
}

export function RetailerEmailRequestFromJSON(json: any): RetailerEmailRequest {
    return RetailerEmailRequestFromJSONTyped(json, false);
}

export function RetailerEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retailerEmail': json['retailerEmail'],
        'retailerName': json['retailerName'],
        'retailerCity': json['retailerCity'],
        'userInputs': ((json['userInputs'] as Array<any>).map(RetailerEmailUserInputFromJSON)),
        'consents': !exists(json, 'consents') ? undefined : json['consents'],
        'hidePdfPrice': !exists(json, 'hidePdfPrice') ? undefined : json['hidePdfPrice'],
        'siteUrl': !exists(json, 'siteUrl') ? undefined : json['siteUrl'],
    };
}

export function RetailerEmailRequestToJSON(value?: RetailerEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retailerEmail': value.retailerEmail,
        'retailerName': value.retailerName,
        'retailerCity': value.retailerCity,
        'userInputs': ((value.userInputs as Array<any>).map(RetailerEmailUserInputToJSON)),
        'consents': value.consents,
        'hidePdfPrice': value.hidePdfPrice,
        'siteUrl': value.siteUrl,
    };
}


